export enum LaunchTag {
  F7 = 'F7',
  F8_30 = 'F8_30',
}

export type ComputedShiftTags = {
  launchTag?: LaunchTag
}

export enum ShiftTag {
  VIP = 'VIP',
  NoBackfill = 'NO_BACKFILL',
  Ignore = 'IGNORE',
  Interview = 'INTERVIEW',
  Orientation = 'ORIENTATION',
  National = 'NATIONAL',
  Enterprise1 = 'ENTERPRISE_ONE',
  Enterprise2 = 'ENTERPRISE_TWO',
  Enterprise3 = 'ENTERPRISE_THREE',
  Enterprise4 = 'ENTERPRISE_FOUR',
  Enterprise5 = 'ENTERPRISE_FIVE',
  Pod0 = 'POD_ZERO',
  Pod1 = 'POD_ONE',
  Pod2 = 'POD_TWO',
  Pod3 = 'POD_THREE',
  Pod4 = 'POD_FOUR',
  Pod5 = 'POD_FIVE',
  Pod6 = 'POD_SIX',
  Pod7 = 'POD_SEVEN',
  Pod8 = 'POD_EIGHT',
  Pod9 = 'POD_NINE',
  Pod10 = 'POD_TEN',
  Growth = 'GROWTH',
  T2H = 'T2H',
  T2HFlex = 'T2H_FLEX',
  DayLabor = 'DAY_LABOR',
  TimeMorning = 'TIME_MORNING',
  TimeAfternoon = 'TIME_AFTERNOON',
  TimeEvening = 'TIME_EVENING',
  TimeOvernight = 'TIME_OVERNIGHT',
}

export enum ShiftTagExcludingPods {
  VIP = 'VIP',
  NoBackfill = 'NO_BACKFILL',
  Ignore = 'IGNORE',
  Interview = 'INTERVIEW',
  Orientation = 'ORIENTATION',
  T2H = 'T2H',
  T2HFlex = 'T2H_FLEX',
  DayLabor = 'DAY_LABOR',
  TimeMorning = 'TIME_MORNING',
  TimeAfternoon = 'TIME_AFTERNOON',
  TimeEvening = 'TIME_EVENING',
  TimeOvernight = 'TIME_OVERNIGHT',
}

export enum ForwardFillMax {
  NONE = 'NONE', // DEPRECATED
  // All eligible workers with experience at the business notified
  EXPERIENCED = 'EXPERIENCED', // DEPRECATED
  EXPERIENCED_FIRST = 'EXPERIENCED_FIRST',
  EXPERIENCED_ONLY = 'EXPERIENCED_ONLY',
  // All favorites at the business notified
  FAVORITES = 'FAVORITES',
  INVITED_ONLY = 'INVITED_ONLY',
  INVITED_FIRST = 'INVITED_FIRST',
  INEXPERIENCED_ONLY = 'INEXPERIENCED_ONLY',
  // Include Ghost workers in the list
  GHOST_INCLUDED = 'GHOST_INCLUDED',
  OPS_MANAGED = 'OPS_MANAGED',
}

export const DEFAULT_FORWARD_FILL_MAXES: Array<ForwardFillMax> = [
  ForwardFillMax.GHOST_INCLUDED,
  ForwardFillMax.NONE,
]

export const forwardFillMaxMenuItems: Array<{
  value: ForwardFillMax
  label: string
  secondaryLabel?: string
  disabled?: boolean
}> = [
  {
    value: ForwardFillMax.NONE,
    label: 'None',
    secondaryLabel: 'Deprecated - use Ghost Workers Included',
    disabled: true,
  },
  { value: ForwardFillMax.INVITED_FIRST, label: 'Invited First' },
  { value: ForwardFillMax.INVITED_ONLY, label: 'Invited Only' },
  { value: ForwardFillMax.FAVORITES, label: 'Favorites Only' },
  {
    value: ForwardFillMax.OPS_MANAGED,
    label: 'Ops Managed',
  },
  {
    value: ForwardFillMax.EXPERIENCED,
    label: 'Previously Worked Workers',
    secondaryLabel: 'Deprecated',
    disabled: true,
  },
  {
    value: ForwardFillMax.EXPERIENCED_ONLY,
    label: 'Experienced Only',
  },
  {
    value: ForwardFillMax.EXPERIENCED_FIRST,
    label: 'Experienced First',
  },
  {
    value: ForwardFillMax.INEXPERIENCED_ONLY,
    label: 'Inexperienced Only',
  },
  {
    value: ForwardFillMax.GHOST_INCLUDED,
    label: 'Ghost Workers Included',
  },
] as const

export enum AssigneeDisplay {
  SCALED_OPS = 'SCALED_OPS',
  CUSTOMER_OPS = 'CUSTOMER_OPS',
}

export enum ForwardFillRenotificationMethod {
  NONE = 'NONE',
  SMS = 'SMS',
}

export enum PaymentType {
  MANUAL = 'MANUAL',
  AUTO = 'AUTO',
  AUTO_WEEKLY = 'AUTO_WEEKLY',
}

export enum InvitedWorkers {
  ALL = 'ALL',
  FAVORITES_ONLY = 'FAVORITES_ONLY',
  FAVORITES_FIRST = 'FAVORITES_FIRST',
}

export enum ShiftStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
}

export enum ShiftSignupStatus {
  ALLOWED = 'ALLOWED',
  DISALLOWED = 'DISALLOWED',
}

export const shiftSignupStatusMenuItems: Array<{
  value: ShiftSignupStatus
  label: string
}> = [
  { value: ShiftSignupStatus.ALLOWED, label: 'Allowed' },
  { value: ShiftSignupStatus.DISALLOWED, label: 'Disallowed' },
] as const

export enum ShiftNotificationStatus {
  ALLOWED = 'ALLOWED',
  DISALLOWED = 'DISALLOWED',
}
